import { EnvUtils } from '@ausz/utils';

export default class Environment {
  static host = EnvUtils.removePortIfNotIp(process.env.REACT_APP_HOST || '');
}
